{
  "title": "الإعدادات",
  "description": "ملفك الشخصي واللغة والأمان والإشعارات وبيانات الشركة.",
  "tabs": {
    "profile": "الملف الشخصي",
    "security": "الأمان",
    "notifications": "الإشعارات",
    "organization": "الشركة"
  },
  "profile": {
    "title": "الملف الشخصي",
    "description": "اسمك ولغة اللوحة والمنطقة الزمنية.",
    "name": "الاسم",
    "language": "اللغة",
    "languageHint": "لغة اللوحة والرسائل التي تصلك على البريد.",
    "timeZone": "المنطقة الزمنية",
    "timeZoneHint": "تظهر بها الأوقات في اللوحة والرسائل والتقارير.",
    "saved": "تم حفظ الملف الشخصي",
    "zones": {
      "riyadh": "الرياض",
      "dubai": "دبي",
      "kuwait": "الكويت",
      "qatar": "الدوحة",
      "bahrain": "المنامة",
      "muscat": "مسقط",
      "cairo": "القاهرة",
      "london": "لندن",
      "utc": "التوقيت العالمي"
    },
    "email": {
      "title": "البريد الإلكتروني",
      "description": "تسجّل الدخول به وتصلك عليه الرسائل.",
      "change": "تغيير البريد",
      "verified": "تم التحقق",
      "pendingTitle": "بانتظار التأكيد",
      "pendingBody": "أرسلنا رابط تأكيد إلى {{email}}. يبقى بريدك الحالي فعّالًا حتى تفتح الرابط.",
      "demoOpen": "افتح رابط التأكيد",
      "cancel": "إلغاء التغيير",
      "dialogTitle": "تغيير البريد الإلكتروني",
      "dialogDescription": "نرسل رابط تأكيد إلى البريد الجديد، ولا يتغيّر شيء قبل التأكيد.",
      "new": "البريد الجديد",
      "password": "كلمة المرور الحالية",
      "passwordHint": "للتأكد من أنك صاحب الحساب.",
      "send": "أرسل رابط التأكيد",
      "sent": "أرسلنا رابط التأكيد إلى البريد الجديد",
      "confirmed": "تم تغيير بريدك"
    }
  },
  "security": {
    "password": {
      "title": "كلمة المرور",
      "description": "استخدم كلمة مرور طويلة لا تستخدمها في مكان آخر.",
      "lastChanged": "آخر تغيير {{when}}.",
      "current": "كلمة المرور الحالية",
      "new": "كلمة المرور الجديدة",
      "confirm": "تأكيد كلمة المرور الجديدة",
      "submit": "تغيير كلمة المرور",
      "othersSignedOut": "عند تغييرها نسجّل خروجك من كل الأجهزة الأخرى.",
      "changed": "تم تغيير كلمة المرور",
      "changedBody": "سجّلنا خروجك من الأجهزة الأخرى."
    },
    "twoFactor": {
      "title": "المصادقة الثنائية",
      "description": "رمز من تطبيق المصادقة مع كلمة المرور عند تسجيل الدخول.",
      "on": "مفعّلة",
      "off": "غير مفعّلة",
      "onBody": "حسابك محمي. نطلب رمز التطبيق عند الدخول من أي جهاز جديد.",
      "offBody": "فعّلها لحماية السيرفرات والفواتير إذا تسرّبت كلمة المرور.",
      "codesLeft_zero": "لم يتبقَّ لديك أي رمز استرداد. أنشئ رموزًا جديدة.",
      "codesLeft_one": "تبقّى رمز استرداد واحد.",
      "codesLeft_two": "تبقّى رمزا استرداد.",
      "codesLeft_few": "تبقّت {{count}} رموز استرداد.",
      "codesLeft_many": "تبقّى {{count}} رمز استرداد.",
      "codesLeft_other": "تبقّى {{count}} رمز استرداد.",
      "enable": "تفعيل المصادقة الثنائية",
      "disable": "إيقاف المصادقة الثنائية",
      "regenerate": "إنشاء رموز استرداد جديدة",
      "enabled": "تم تفعيل المصادقة الثنائية",
      "disabled": "تم إيقاف المصادقة الثنائية",
      "requiredByOrg": "شركتك تشترط المصادقة الثنائية على كل الأعضاء، لذلك لا يمكن إيقافها.",
      "requiredByOrgOff": "شركتك تشترط المصادقة الثنائية على كل الأعضاء. فعّلها الآن، وإلا سنطلبها منك عند الدخول القادم.",
      "disableTitle": "إيقاف المصادقة الثنائية",
      "disableDescription": "بعد الإيقاف تكفي كلمة المرور لتسجيل الدخول. أدخلها للتأكيد.",
      "regenerateTitle": "إنشاء رموز استرداد جديدة",
      "regenerateDescription": "تتوقف الرموز القديمة فورًا. أدخل كلمة المرور للتأكيد.",
      "setup": {
        "title": "تفعيل المصادقة الثنائية",
        "description": "تحتاج إلى تطبيق مصادقة مثل Google Authenticator أو 1Password.",
        "step1": "امسح الرمز بتطبيق المصادقة، أو أدخل المفتاح يدويًا.",
        "step2": "أدخل الرمز المكوّن من 6 أرقام الظاهر في التطبيق.",
        "qr": "رمز QR لإضافة الحساب في تطبيق المصادقة",
        "manual": "أو أدخل هذا المفتاح يدويًا",
        "code": "رمز التحقق",
        "demoCode": "في النسخة التجريبية استخدم {{code}}",
        "wrongCode": "الرمز غير صحيح أو انتهت صلاحيته",
        "verify": "تحقق وفعّل"
      },
      "codes": {
        "title": "احفظ رموز الاسترداد",
        "description": "إذا فقدت هاتفك، ادخل بأحد هذه الرموز. كل رمز يصلح مرة واحدة، ولن نعرضها مرة أخرى، لذلك احفظها في مكان آمن.",
        "newTitle": "رموز استرداد جديدة",
        "newDescription": "توقفت الرموز القديمة. احفظ الرموز الجديدة في مكان آمن.",
        "download": "تنزيل الرموز",
        "copy": "نسخ الرموز",
        "copied": "تم نسخ الرموز",
        "saved": "حفظت الرموز في مكان آمن"
      },
      "gate": {
        "title": "فعّل المصادقة الثنائية للمتابعة",
        "body": "شركتك تشترط المصادقة الثنائية على كل الأعضاء. فعّلها هنا، ثم تابع استخدام اللوحة."
      }
    },
    "sessions": {
      "title": "الأجهزة المتصلة",
      "description": "الأجهزة المسجّل دخولها إلى حسابك الآن.",
      "device": "{{browser}} على {{os}}",
      "current": "هذا الجهاز",
      "activeNow": "نشط الآن",
      "lastActive": "آخر نشاط {{when}}",
      "signedIn": "سجّل الدخول {{when}}",
      "signOut": "تسجيل الخروج",
      "signOutOthers": "تسجيل الخروج من الأجهزة الأخرى",
      "confirmOneTitle": "تسجيل الخروج من هذا الجهاز؟",
      "confirmOneDescription": "سنسجّل خروج {{device}}، ويمكن الدخول منه مرة أخرى بكلمة المرور.",
      "confirmAllTitle": "تسجيل الخروج من الأجهزة الأخرى؟",
      "confirmAllDescription_zero": "لا توجد أجهزة أخرى.",
      "confirmAllDescription_one": "سنسجّل خروج جهاز واحد. يبقى هذا الجهاز متصلًا.",
      "confirmAllDescription_two": "سنسجّل خروج جهازين. يبقى هذا الجهاز متصلًا.",
      "confirmAllDescription_few": "سنسجّل خروج {{count}} أجهزة. يبقى هذا الجهاز متصلًا.",
      "confirmAllDescription_many": "سنسجّل خروج {{count}} جهازًا. يبقى هذا الجهاز متصلًا.",
      "confirmAllDescription_other": "سنسجّل خروج {{count}} جهاز. يبقى هذا الجهاز متصلًا.",
      "revoked": "تم تسجيل الخروج من الجهاز",
      "revokedAll": "تم تسجيل الخروج من الأجهزة الأخرى"
    },
    "activity": {
      "title": "سجل الدخول",
      "description": "عمليات الدخول وتغييرات الأمان في آخر 30 يومًا.",
      "empty": "لا يوجد نشاط في آخر 30 يومًا",
      "failures_zero": "لا توجد محاولات فاشلة.",
      "failures_one": "هناك محاولة دخول فاشلة واحدة. إذا لم تكن منك، غيّر كلمة المرور.",
      "failures_two": "هناك محاولتا دخول فاشلتان. إذا لم تكن منك، غيّر كلمة المرور.",
      "failures_few": "هناك {{count}} محاولات دخول فاشلة. إذا لم تكن منك، غيّر كلمة المرور.",
      "failures_many": "هناك {{count}} محاولة دخول فاشلة. إذا لم تكن منك، غيّر كلمة المرور.",
      "failures_other": "هناك {{count}} محاولة دخول فاشلة. إذا لم تكن منك، غيّر كلمة المرور.",
      "kinds": {
        "sign_in": "دخول ناجح",
        "sign_in_failed": "محاولة دخول فاشلة",
        "two_factor_failed": "رمز مصادقة غير صحيح",
        "password_changed": "تغيير كلمة المرور",
        "two_factor_enabled": "تفعيل المصادقة الثنائية",
        "two_factor_disabled": "إيقاف المصادقة الثنائية",
        "recovery_codes_generated": "إنشاء رموز استرداد",
        "email_changed": "تغيير البريد الإلكتروني",
        "sessions_revoked": "تسجيل الخروج من أجهزة"
      }
    }
  },
  "notifications": {
    "title": "الإشعارات",
    "description": "اختر ما يصلك على البريد وما يظهر في اللوحة. يُحفظ كل تغيير فورًا.",
    "event": "الحدث",
    "channels": {
      "email": "البريد",
      "inApp": "اللوحة"
    },
    "groups": {
      "billing": "الفوترة",
      "servers": "السيرفرات",
      "updates": "التحديثات",
      "ai": "نقاط الذكاء الاصطناعي",
      "team": "الفريق",
      "support": "الدعم",
      "security": "الأمان"
    },
    "events": {
      "payment_failed": "فشل الدفع",
      "invoice_paid": "تم دفع فاتورة",
      "trial_ending": "قرب نهاية التجربة",
      "credits_low": "اقتراب نفاد النقاط",
      "server_activated": "تفعيل سيرفر",
      "server_grace": "سيرفر غير متصل بـ bPanel",
      "update_available": "تحديث متاح لسيرفر",
      "release_published": "إصدار جديد من bPanel",
      "member_joined": "انضمام عضو إلى الفريق",
      "ticket_reply": "رد على تذكرة",
      "ticket_resolved": "حل تذكرة",
      "security_sign_in": "دخول من جهاز جديد",
      "credits_exhausted": "نفدت النقاط",
      "credits_topped_up": "شحن تلقائي للنقاط",
      "server_past_due": "سيرفر بانتظار دفعة التجديد",
      "server_locked": "قفل لوحة تحكم سيرفر",
      "server_unlocked": "فتح لوحة تحكم سيرفر"
    },
    "locked": "هذا البريد مطلوب لدورك ولا يمكن إيقافه",
    "lockedShort": "البريد مطلوب",
    "billingEmail": "رسائل الفواتير تصل أيضًا إلى بريد الفوترة {{email}}.",
    "billingEmailLink": "تعديل بيانات الفوترة",
    "saved": "تم حفظ التغيير"
  },
  "organization": {
    "title": "بيانات الشركة",
    "description": "يظهر الاسم والدولة للفريق وفي الفواتير.",
    "readOnly": "تعديل بيانات الشركة متاح للمالك والمدير فقط.",
    "name": "اسم الشركة",
    "nameHint": "الاسم القانوني يُعدّل من بيانات الفوترة.",
    "country": "الدولة",
    "billingEmail": "بريد الفوترة",
    "billingEmailHint": "تصل إليه الفواتير والإيصالات.",
    "billingEmailLink": "تعديله من بيانات الفوترة",
    "saved": "تم حفظ بيانات الشركة",
    "logo": {
      "title": "الشعار",
      "description": "يظهر في قائمة الشركات وفي رسائل الدعوة.",
      "alt": "شعار {{name}}",
      "upload": "رفع شعار",
      "replace": "تغيير الشعار",
      "remove": "إزالة",
      "hint": "PNG أو JPG أو SVG أو WebP، حتى 512 كيلوبايت. يُفضّل أن يكون مربعًا.",
      "type": "نوع الملف غير مدعوم. استخدم PNG أو JPG أو SVG أو WebP.",
      "size": "الملف أكبر من 512 كيلوبايت.",
      "saved": "تم حفظ الشعار"
    },
    "delete": {
      "title": "حذف الشركة",
      "description": "حذف نهائي لا يمكن التراجع عنه.",
      "what1": "نحذف الفريق والدعوات ومفاتيح التفعيل وتذاكر الدعم.",
      "what2": "نحتفظ بالفواتير المدفوعة للمدة التي يشترطها القانون، ويمكنك أن تطلب نسخة منها.",
      "what3": "قبل الحذف، ألغِ اشتراكات كل السيرفرات وسدّد أي مبلغ مستحق.",
      "blockedTitle": "لا يمكن حذف الشركة الآن",
      "blockedServers_zero": "لا توجد سيرفرات فعّالة.",
      "blockedServers_one": "هناك سيرفر واحد باشتراك فعّال.",
      "blockedServers_two": "هناك سيرفران باشتراك فعّال.",
      "blockedServers_few": "هناك {{count}} سيرفرات باشتراك فعّال.",
      "blockedServers_many": "هناك {{count}} سيرفرًا باشتراك فعّال.",
      "blockedServers_other": "هناك {{count}} سيرفر باشتراك فعّال.",
      "toServers": "عرض السيرفرات",
      "blockedBalance": "عليك مبلغ مستحق:",
      "toBilling": "عرض الفوترة",
      "ownerOnly": "حذف الشركة متاح للمالك فقط.",
      "button": "حذف الشركة",
      "confirmTitle": "حذف {{name}} نهائيًا؟",
      "confirmDescription": "لا يمكن التراجع. اكتب اسم الشركة للتأكيد.",
      "confirm": "حذف نهائي",
      "done": "تم حذف {{name}}"
    }
  }
}
